const portalId = process.env.REACT_APP_BUILD_SITE;

/**
 * @param {Array} portalsWithoutArchiveOption
 * Evita conflictos con eventos y clonner.
 */
const portalsWithoutArchiveOption = ['24MX', 'UBPE'];

export function isPortalWithoutArchiveOption() {
  return portalsWithoutArchiveOption.includes(portalId);
}

const transitionPlandIds = [111, 112, 113, 114, 115, 116, 117, 118, 1150, 1151, 11001, 15000, 26400];
const bundleCreditsIds = [101, 102, 103, 104, 105, 106, 107, 108, 1050, 1051, 1052, 1053, 16210, 16400, 21001, 25000];
const mirrorCreditsIdsUrbania = [301, 302, 303, 304, 305, 306, 307, 350, 351, 31001, 35000, 36400];

export function getIsTransitionPlandId(planId) {
  return transitionPlandIds.includes(planId);
}

export function getIsTransitionOrBundleCredit(planId) {
  return (
    getIsTransitionPlandId(planId) || bundleCreditsIds.includes(planId) || mirrorCreditsIdsUrbania.includes(planId)
  );
}
/**
 * La función valida si se tienen créditos de transición.
 * @param {Array} branchCreditsArray Se obtiene un array de sucursales con sus créditos.
 * @param {Object} globalCreditsObject Se obtiene un objeto que con tiene todos los créditos.
 * @returns {Boolean} se retorna si el usuario tienen o no créditos de transición.
 */
export const hasCreditsTransition = (branchCreditsArray, globalCreditsObject) => {
  if (!branchCreditsArray) return false;
  // Si tenemos más de 1 sucursal validamos los créditos desde globalCredits:
  if (branchCreditsArray.length > 1 && globalCreditsObject) {
    return (
      globalCreditsObject.creditItems &&
      globalCreditsObject.creditItems.some(credit => getIsTransitionPlandId(credit.publicationPlanId))
    );
  }
  // Si sólo tenemos 1 sucursal validamos los créditos desde branchCredits:
  return (
    branchCreditsArray[0] &&
    branchCreditsArray[0].creditItems &&
    branchCreditsArray[0].creditItems.some(credit => getIsTransitionPlandId(credit.publicationPlanId))
  );
};
